import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-file-viewer',
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.scss']
})
export class FileViewerComponent implements OnInit {

  url: string;
  ready = false;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    
    // var origin = window.location.origin + '/file?url=';
    // this.url = window.location.href;
    // this.url = this.url.replace(origin, '');
    // this.url = decodeURIComponent(this.url);
    // console.log(this.url);    
    // setTimeout(this.loadPDF, 3000);    
    this.loadPDF();
    var frame = <HTMLIFrameElement>document.getElementById('assetDivIdMob');   
    
    var loopingChecking = 50;
    var loopCount = 0;
    while(loopingChecking--){
      loopCount++;
      if(this.ready) break;
      setTimeout(()=>{
        if(frame.contentDocument == null){
          this.ready = true;                 
          console.log('ready: ' + this.ready);          
        }else{
          frame.src = this.url;
          console.log(frame.contentDocument == null)
        }
      }, 3000*loopCount);  
      
    }
          
          
  }

  showLoading(){
    console.log('url: '+this.url);
  }

  loadPDF(): void {
    var origin = window.location.origin + '/file?url=';
    this.url = window.location.href;
    this.url = this.url.replace(origin, '');
    this.url = decodeURIComponent(this.url);
    console.log(this.url);    
    this.url = 'https://docs.google.com/gview?url=' + this.url + '&embedded=true';  
    // var t = this.url.slice(this.url.length - 4, this.url.length);
    // if(t != '.pdf'){      
    //   this.url = 'https://docs.google.com/gview?url=' + this.url + '&embedded=true';  
    //   // this.url = 'https://view.officeapps.live.com/op/embed.aspx?src=' + this.url;  
    // }else{
    //   console.log('is pdf');
    // }
    var frame = <HTMLIFrameElement>document.getElementById('assetDivIdMob');    
    console.log(frame.contentDocument == null);
    frame.src = this.url;    
  }
}
